import { useRef, useState } from 'react';
import { Pencil } from 'lucide-react';
import { TooltipButton } from './TooltipButton';
import './job-setup-atlas.css';

export function SetupTypeName({
  name,
  disabled,
  onChange,
}: {
  name: string;
  disabled: boolean;
  onChange: (name: string) => void;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name);
  const pencil = useRef<HTMLButtonElement>(null);
  const finish = (save: boolean, returnFocus = false) => {
    if (save && !disabled && draft.trim() && draft.trim() !== name) onChange(draft.trim());
    setEditing(false);
    if (returnFocus) requestAnimationFrame(() => pencil.current?.focus());
  };
  return (
    <div className="setup-type-name">
      {editing && !disabled ? (
        <input
          aria-label="Document type name"
          value={draft}
          autoFocus
          onFocus={(event) => event.target.select()}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={() => finish(true)}
          onKeyDown={(event) => {
            if (event.nativeEvent.isComposing || (event.key !== 'Enter' && event.key !== 'Escape'))
              return;
            event.preventDefault();
            event.stopPropagation();
            finish(event.key === 'Enter', true);
          }}
        />
      ) : (
        <>
          <h2>{name}</h2>
          <TooltipButton
            ref={pencil}
            type="button"
            className="icon-button"
            aria-label="Rename document type"
            disabled={disabled}
            tooltip={disabled ? 'Content Central controls this name' : 'Rename'}
            onClick={() => {
              setDraft(name);
              setEditing(true);
            }}
          >
            <Pencil size={16} />
          </TooltipButton>
        </>
      )}
    </div>
  );
}
